/**
 * Registers `videoproject_create` in the entityCreationRegistry so the
 * sidebar "+" → Media → New Video row offers VideoProject creation.
 *
 * The actual handler lives in ../commands/videoProjectCommands.ts.
 */

import { entityCreationRegistry } from '../../../services/entityCreationRegistry';

entityCreationRegistry.register({
  commandId: 'videoproject_create',
  entityType: 'VideoProject',
  displayName: 'Video',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'FilmReel',
    phosphorWeight: 'duotone',
  },
  description: 'Create a video timeline project with AI editing tools',
  canCreateInFolder: true,
  openAfterCreate: true,
  // 'media' is a valid category per EntityCreationMetadata; Image Studio and
  // MediaGen both use it.
  category: 'media',
  sortOrder: 6,
});
